import isNil from 'lodash/isNil'

// BE returns string for miDocument `inference_result.type` field
// but it's value could only be either null, empty string or one of the DocumentKind
// So the type of this field could be DocumentKind in FE but we need to resolve '' to InvalidDocumentType
export const formatInferenceResultType = (inferenceResultType: Maybe<string>): Maybe<DocumentKind> => {
  if (isNil(inferenceResultType)) return inferenceResultType
  if (inferenceResultType === '') return 'INVALID_DOCUMENT_TYPE'
  return inferenceResultType as DocumentKind
}

export const formatMIDocument = (miDocument: MiDocumentSummary): MiDocumentSummary => {
  return {
    ...miDocument,
    inference_result: {
      ...miDocument.inference_result,
      type: formatInferenceResultType(miDocument.inference_result?.type),
    },
  }
}
